<template>
  <div>
    <div
      v-for="(rr,idx) in bestRoutes"
      :key="rr.id"
      @click="emit('select',rr)"
      :id="'r'+idx"
      :class="{'routing-slot':true,rselected:(rr.id==selectedRoute.id),'levelC':(rr.weight.hard!=0),'levelA':(rr.weight.soft<0&&rr.weight.hard==0),'levelB':(rr.weight.soft>0&&rr.weight.hard==0),inFuture:!rr.timePassed}"
    >
      <drop class="drop" @drop="(e)=>emit('dropped',{that:e,on:rr})">
        <drag class="drag" :transfer-data="rr">
          <routing-route :routeData="rr" @removeVehicle="removeVehicle"></routing-route>
        </drag>
      </drop>
    </div>
  </div>
</template>

<script>
import { fetchList } from "~/api/resource";
import { mapGetters } from "vuex";
// :class="{'route-unit':true,'not-available':(route.weight.hard>0),'expired':(route.weight.soft<0)}"
export default {
  name: "routing-route",
  props: {
    previewMode: { type: Boolean, default: false },
    routeData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    // isDone() {
    //   var maybe = false,
    //     now = new Date(),
    //     propableEnd = now.getHours() * 60 + now.getMinutes();
    //   if (
    //     this.route.endTimeMM &&
    //     this.route.endTimeMM + (this.tripIcon == "plane-arrival" ? 60 : 30) <
    //       propableEnd
    //   )
    //     maybe = true;
    //   if (this.route.execLog) {
    //     const last = this.route.execLog[this.route.execLog.length - 1];
    //     if (last && last.time && last.time != "0") return "sure";
    //   }
    //   return maybe ? "maybe" : "";
    // },
    tripIcon() {
      // _log_('>>>',this.routeData.loc_seq_trans,this.routeData.loc_seq_trans.indexOf('AIR'))
      if (this.routeData.destination == "PICKUP") return "walking";
      if (this.routeData.destination == "EXCRS") return "ship";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") === 0)
      if (this.routeData.direction == "ARV") return "plane-arrival";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") > 3)
      if (this.routeData.direction == "DEP") return "plane-departure";
      return "bug";
    },
    tripClass() {
      if (this.routeData.destination == "PICKUP") return "pickup";
      if (this.routeData.destination == "EXCRS") return "excrs";
      if (this.routeData.direction == "DEP") return "departure";
      if (this.routeData.direction == "ARV") return "arrival";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") === 0) return "arrival";
      // if (this.routeData.loc_seq_trans.indexOf("AIR") > 3) return "departure";
      return "error";
    },
  },
  // watch: {
  //   // "routeData.weight.soft": function(newValue) {
  //   //   this.route.weight.soft = newValue;
  //   //   _log_("nnr..eessss.", newValue);
  //   //   // this.$set(this.$data, 'route' , newValue);
  //   // },
  //   "routeData.weight": {
  //     handler: newValue => {
  //       _log_("nnr...", newValue);

  //       // this.$set(this.$data, "route", newValue);
  //     },
  //     deep: true
  //     // immediate:true
  //   }
  // },
  data() {
    return {
      route: this.routeData,
    };
  },
  // created() {
  //   this.route = this.routeData;
  // }
};
</script>
<style>
.item {
  margin-top: 10px;
  margin-right: 40px;
}

.route-unit .pickup {
  background-color: burlywood;
}
.route-unit .excrs {
  background-color: chartreuse;
}
.route-unit .arrival {
  border-top-left-radius: 30%;
  border-bottom-left-radius: 30%;
  background-color: darkcyan;
  color: aliceblue;
}
.route-unit .departure {
  border-top-right-radius: 30%;
  border-bottom-right-radius: 30%;
  background-color: darkmagenta;
  color: aliceblue;
}
.levelA .route-unit .route-info {
  border: 4px solid rgb(112, 4, 4);
}
/* .route-unit.expired {
  border: 2px solid rgb(112, 4, 4);
} */
.levelC .route-unit {
  background-color: rgba(153, 123, 123, 0.2);
  opacity: 0.9;
}
.route-unit .route-info {
  border: 1px solid green;
  border-top-right-radius: 5px;
  padding: 3px;
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.time-sign {
  background-color: darkgreen;
  color: white;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.levelA .route-unit .time-sign {
  background-color: rgb(112, 4, 4);
}
.levelC .route-unit .time-sign {
  background-color: grey;
}
/* .small {
  color: grey;
  font-weight: bold;
  font-size: 10px;
} */
</style>